import { useState } from "react";
import { Info, X, ShieldCheck, FileSignature } from "lucide-react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger,
} from "@/components/ui/dialog";

/**
 * Tiny "About this receipt" affordance for the asynchronous reader path
 * (Public Receipt and Snapshot views). Two-sentence explainer — no link out,
 * no marketing copy — just enough context for an external party who arrived
 * via a shared link with no preamble.
 */
export default function AboutDialog({ variant = "light", testid = "about-trigger" }) {
  const [open, setOpen] = useState(false);
  const isLight = variant === "light"; // light = white text on dark banner
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          data-testid={testid}
          className={`inline-flex items-center gap-1.5 text-[11px] ${isLight ? "text-white/80 hover:text-white" : "text-[var(--ink-soft)] hover:text-[var(--ink)]"}`}
        >
          <Info size={12}/> What is this?
        </button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[480px] rounded-sm" data-testid="about-dialog">
        <DialogHeader>
          <DialogTitle className="display text-[18px]">About this receipt</DialogTitle>
          <DialogDescription className="text-[13px] leading-relaxed">
            FreightCierge is a KATLAS-powered governance layer for port-corridor freight.
            A KATLAS-signed receipt proves who approved what, on what authority and with
            what evidence — without centralising raw operational data.
          </DialogDescription>
        </DialogHeader>
        <div className="mt-1 space-y-2 text-[12px] text-[var(--ink-soft)]">
          <div className="flex gap-2 items-start">
            <ShieldCheck size={13} className="text-[var(--teal)] mt-0.5"/>
            <span><strong className="text-[var(--ink)]">Custody · Authority · Receipts</strong> — the runtime check that decides whether an action is allowed, blocked or escalated.</span>
          </div>
          <div className="flex gap-2 items-start">
            <FileSignature size={13} className="text-[var(--navy)] mt-0.5"/>
            <span>This page shows only public-safe fields. Bearer tokens, certificate text and the full signed envelope stay backend-only.</span>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
